import { useQuery } from "react-query";
import { getDistrict } from "../../../../../actions/Utilities/District";

export default function useDistrict() {
  const {data, isFetching} = useQuery("GetDistrict", getDistrict, {
    refetchOnWindowFocus: false,
  });
  return {data, isFetching};
}
